import { render, staticRenderFns } from "./MyDeviceList.vue?vue&type=template&id=654b7d62&scoped=true"
import script from "./MyDeviceList.vue?vue&type=script&lang=js"
export * from "./MyDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b7d62",
  null
  
)

export default component.exports